import { useTranslation }         from 'next-i18next';
import { useRouter }              from 'next/router';
import SitePage                   from 'components/Site/Page';
import AccessView                 from 'views/Site/Access';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const TITLES = {
  'signup': 'pages.access.signUpTitle',
  'auth': 'pages.access.signInTitle'
};

const AccessPage = (props) => {
  const { t } = useTranslation('landing');
  const { tab = 'signup' } = useRouter().query;
  const title = t(TITLES[tab]);

  return (
    <SitePage
      {...props}
      title={title}
      siteViewClass="flex-column"
      siteViewContentClass="flex-center"
      hideHeaderButton
    >
      <AccessView/>
    </SitePage>
  )
};

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'header']),
    }
  }
};

export default AccessPage;